<template>
  <div class="sidebar">
    <div class="sidebar-content">
      <h2>My Xsensible community</h2>
      <p>My Xsensible community</p>
      <a @click.prevent="goToXsensibles()">
        My Xsensibles
      </a>
      <div style="margin-top: 90px">
        <a @click.prevent="logout">Logout</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Sidebar',
  methods: {
    logout() {
      this.$store.commit('setMobileMenuOpen', false)
      this.$store.commit('logout')
      this.$router.replace('/')
    },
    goToXsensibles() {
      this.$store.commit('setMobileMenuOpen', false)
      this.$router.push('my-xsensibles')
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar {
  margin: 160px 0;
  padding-left: 136px;

  .sidebar-content {
    position: fixed;
    a {
      cursor: pointer;
    }

    @media screen and (max-width: 1365px) {
      position: unset;
    }
  }

  h2 {
    margin-top: 0;
  }
  @media screen and (max-width: 1706px) {
    padding: 0 30px;
  }

  @media screen and (max-width: 1365px) {
    display: none;
  }
}
</style>
